import * as client from "../ClientConsumer";
import { generatePath } from "react-router-dom";
import { RequestCriteriaType } from "./PostService.types";
import { prepareSearchCriteriaWithoutCaching } from "./ApiUtility";

const routes = {
    GET_MEDIA_LIST: "/media-list",
};

export type MediaListType = {
    commentId: number;
    cursor: number;
    imageUrl: number;
    postId: number;
};

export function getMediaList(
    sortCriteria?: RequestCriteriaType,
): Promise<MediaListType[]> {
    return client
        .getData(
            generatePath(routes.GET_MEDIA_LIST) +
                prepareSearchCriteriaWithoutCaching(sortCriteria),
        )
        .then((res) => res.data.images);
}
